import { httpGetAndParse } from '../../utils/fetchService';

export const fetchColumnHeaders = () =>
  httpGetAndParse({
    route: `/api/reports/estimate-summary/column-headers`,
    errorMessage: 'Fetching column headers for estimate summary report failed',
  });
